// material
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/system';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';

// ----------------------------------------------------------------------

interface LogoProps extends BoxProps {
  isOffset?: boolean;
}

export default function LogoFacebook({ sx, isOffset = true }: LogoProps) {
  const { palette } = useTheme();
  const { event } = useGoogleTagManager();

  const mediaInteraction = (media: string) => {
    event({
      path: media,
      event: 'Contact'
    });
  };
  return (
    <Box
      sx={{
        width: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        height: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        ...sx
      }}
    >
      <a
        onClick={() => mediaInteraction('Facebook')}
        target={'_blank'}
        href="https://www.facebook.com/iBANOnlineMX"
        rel="noreferrer"
        aria-label="Icon open facebook"
      >
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21" cy="21" r="21" fill={palette.primary.main} />
          <g clip-path="url(#clip0_724_10182)">
            <path
              d="M16.2008 22.0201H18.5718V31.7811C18.5718 31.9738 18.7279 32.13 18.9206 32.13H22.9407C23.1335 32.13 23.2896 31.9738 23.2896 31.7811V22.0661H26.0153C26.1925 22.0661 26.3416 21.9331 26.3618 21.7571L26.7758 18.1636C26.7872 18.0647 26.7559 17.9657 26.6897 17.8915C26.6235 17.8173 26.5287 17.7748 26.4293 17.7748H23.2898V15.5222C23.2898 14.8432 23.6554 14.4988 24.3766 14.4988C24.4793 14.4988 26.4293 14.4988 26.4293 14.4988C26.622 14.4988 26.7782 14.3426 26.7782 14.15V10.8515C26.7782 10.6587 26.622 10.5026 26.4293 10.5026H23.6003C23.5804 10.5016 23.5361 10.5 23.4708 10.5C22.9799 10.5 21.2737 10.5964 19.9259 11.8362C18.4326 13.2102 18.6402 14.8554 18.6898 15.1406V17.7747H16.2008C16.0081 17.7747 15.8519 17.9309 15.8519 18.1236V21.6712C15.8519 21.8639 16.0081 22.0201 16.2008 22.0201Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_724_10182">
              <rect width="21.63" height="21.63" fill="white" transform="translate(10.5 10.5)" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </Box>
  );
}
